'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './survey-public.routes';

export class SurveyPublicComponent {
  constructor(Auth, SurveysService, SurveyResultsService, dialogs, $uibModal, $stateParams, $scope, Config, User) {
    'ngInject';
    this.baseContainerClass = Config.getPlatformConfig().getBaseContainerClass();
    this.SurveysService = SurveysService;
    this.SurveyResultsService = SurveyResultsService;
    this.isAdmin = Auth.isAdminSync;
    this.Auth = Auth;
    this.User = User;
    this.$scope = $scope;

    this.model = {};
    this.surveyId = $stateParams.id;
    this.surveyResult = {
      survey: this.surveyId
    };

    this.dialogs = dialogs;
    this.$uibModal = $uibModal;

    this.formName = $stateParams.name;

    this.SurveysService.getPublic({id: this.surveyId}, (survey) => {
      this.survey = survey;

      this.allowed = true;

      /* Check status */
      if (this.survey.status == 'closed') {
        this.allowed = false;
        this.closed = true;
      } else if (this.survey.status == 'draft') {
        this.allowed = false;
        this.draft = true;
      }

      let schema = {
        "type": "object",
        "properties": {},
        "required": []
      };

      let form = [];

      for (let i = 0; i < survey.questions.length; i++) {
        let key = "question_" + i;

        if (survey.questions[i].required) {
          schema.required.push(key);
        }

        switch (survey.questions[i].type) {
          case 'text':
            schema.properties[key] = {
              "title": survey.questions[i].question,
              "type": "string"
            };
            break;
          case 'select-one':
            schema.properties[key] = {
              "title": survey.questions[i].question,
              "type": "string",
              enum: survey.questions[i].answers
            };
            break;
          case 'select-many':
            schema.properties[key] = {
              "title": survey.questions[i].question,
              "type": "array",
              "items": {
                enum: survey.questions[i].answers
              }
            };
            break;
        }
        form.push(key);
      }

      this.schema = schema;
      this.form = form;
    }, err => {
      console.log("Could not retrieve survey from server.")
    })

  }

  create(form) {
    this.submitted = true;
    this.sendFailure = false;

    var that = this;

    // First we broadcast an event so all fields validate themselves
    this.$scope.$broadcast('schemaFormValidate');

    if (form.$valid) {

      var onSuccess = () => {
        var dlg = this.dialogs.notify("Success", "The survey has been sent successfully");
        dlg.result.then(() => {
          that.sendSuccess = true;
        });
      };

      var onError = err => {
        this.sendFailure = true;
      };

      this.surveyResult.answers = this.model;
      this.SurveyResultsService.save(this.surveyResult, onSuccess, onError);
    }
  }
}

export default angular.module('conduu.surveyPublic', [uiRouter])
  .config(routes)
  .component('surveyPublic', {
    template: require('./survey-public.html'),
    controller: SurveyPublicComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/survey/public/survey-public.component.js